export default {
    are_you_sure: "Are you sure?",
    cancel: "Cancel",
    yes: "Yes",
    cancelled: "Cancelled",
    action_cancelled: "Action has been canceled.",
    ok: "OK",
    delete_warning: "You won't be able to revert this!",
    no_cancel: "No, cancel!",
    yes_delete: "Yes, delete it.",
    deletion_cancelled: "Deletion has been canceled.",
    invalid_title: "Validation Error",
    invalid_single: "There is 1 invalid field.",
    invalid_multiple: "There are %count% invalid fields.",
    clipboard_success_message: "Copied to clipboard",
    clipboard_success_title: "Success",
    clipboard_error_message: "Failed to copy",
    clipboard_error_title: "Error",
};
